module.exports = __webpack_public_path__ + "img/background-login.9cd3f55a.png";